import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ComponentDefinition } from '@/pages/reports/schemas';
import { ComponentConfigForm } from '@/pages/reports/new/components/ConfigForm';
import { ThematicTemplatePanel } from '@/pages/reports/new/components/ThematicTemplatePanel';
import type { ThematicSessionTemplate } from '@/pages/reports/utils/thematicSessionTemplates';

interface NewComponentConfigCardProps {
  selectedComponent: ComponentDefinition;
  componentProps: Record<string, any>;
  validationErrors: Record<string, string>;
  onPropChange: (_key: string, _value: string | any[]) => void;
  onSave: () => void;
  onCancel: () => void;
  thematicTemplates: ThematicSessionTemplate[];
  selectedTemplateId: string;
  onTemplateSelect: (_templateId: string) => void;
  onSaveTemplate: (_name: string) => void;
  onUpdateTemplate: (_name: string) => void;
  onDeleteTemplate: () => void;
}

export const NewComponentConfigCard: React.FC<NewComponentConfigCardProps> = ({
  selectedComponent,
  componentProps,
  validationErrors,
  onPropChange,
  onSave,
  onCancel,
  thematicTemplates,
  selectedTemplateId,
  onTemplateSelect,
  onSaveTemplate,
  onUpdateTemplate,
  onDeleteTemplate,
}) => {
  if (!selectedComponent) {
    return null;
  }

  return (
    <Card>
      <CardHeader className="border-b">
        <CardTitle className="text-xl">Configurar {selectedComponent.name}</CardTitle>
        <CardDescription>Preencha os campos para adicionar o componente</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4 mt-6">
        {selectedComponent.type === 'thematic-session' && (
          <ThematicTemplatePanel
            thematicTemplates={thematicTemplates}
            selectedTemplateId={selectedTemplateId}
            onTemplateSelect={onTemplateSelect}
            onSaveTemplate={onSaveTemplate}
            onUpdateTemplate={onUpdateTemplate}
            onDeleteTemplate={onDeleteTemplate}
          />
        )}
        <ComponentConfigForm
          component={selectedComponent}
          componentProps={componentProps}
          validationErrors={validationErrors}
          onPropChange={onPropChange}
          onSave={onSave}
          onCancel={onCancel}
          saveButtonText="Adicionar"
        />
      </CardContent>
    </Card>
  );
};
